import { useAsyncExecutor } from "async-executor-hook";
import { Paginator } from "primereact/paginator";
import queryString from "query-string";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { FormArray, useFormConfig } from "rectangular-forms";
import { Authorization } from "../../common/AuthorizationCpt";
import IconViewUser from "../../images/ic_eye_users.svg";
import IconEditUserCris from "../../images/icon_edit_profile_cris.svg";
import IconEditUser from "../../images/icon_edit_user.svg";
import IconItem from "../../images/icon_item.svg";
import IconTrashUserCris from "../../images/icon_trash_profile_cris.svg";
import IconTrashUser from "../../images/icon_trash_user.svg";
import LoadingSpinner from "../../images/loading_gray.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Modal from "../Modal/Modal";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import UsersManagementSidebar from "./UsersManagementSidebar";
import {
  Button,
  Container1,
  DivMarginTop,
  MainButton,
  MenuContainerUser,
  UsersContainer,
  VolanteId,
} from "./UsersManagementStyles";
import { getErrorValueResponse } from "../../common/error/Error";

import { Menu } from "primereact/menu";
import {
  DivUserMenu,
  DivUserMenuLabel,
} from "../UsersManagementAdmin/UsersManagementAdminStyles";
import PaymentLoader from "../PaymentLoader/PaymentLoader";
import {
  BodyContainerTableCommon,
  ContainerConfigurateCommon,
  ContainerGridColumnsTableCommon,
  ContainerScrollCommon,
  TableHeaderCommonResponsive,
} from "../../common/components/TableResponsive";

const UsersManagementTableNew = (props) => {
  const { userCompanyMe, userProfileMe, userInfo, loadUsers } = props;
  const formConfig = useFormConfig({
    createForm: () => {
      const form = new FormArray([]);
      return form;
    },
  });
  const { loadSucceed } = formConfig;

  useEffect(() => {
    loadSucceed([]);
  }, [loadSucceed]);

  const [showModalEdit, updateModalEdit] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [dataUser, setDataUser] = useState<any>();
  const [dataUserEdit, setDataUserEdit] = useState(false);
  const [showProfileTwoShowUser, setShowProfileTwoShowUser] = useState(false);
  const onClose = () => {
    setShowModalDelete(!showModalDelete);
  };
  const showEdit = () => {
    updateModalEdit(!showModalEdit);
  };
  const deleteUser = useAsyncExecutor(
    (params: any) => {
      const { id } = params;
      return networkBackendRequest(`/users/${id}/`, HTTP_METHODS.DELETE);
    },
    {
      onSuccess: () => {
        setShowModalDeleteUserAgent(true);
        setShowModalDelete(false);
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        updateMessageError(errorMessage);
        updateShowModalError(true);
        setShowModalDelete(false);
      },
    }
  );
  const [showModalConfimation, setShowModalConfimation] = useState(false);
  const showModalHide = () => {
    setShowModalConfimation(!showModalConfimation);
  };
  const [messageTypeEditCreate, setMessageTypeEditCreate] = useState("");
  const [titleTypeEditCreate, settitleTypeEditCreate] = useState("");
  const [showModalDeleteUserAgent, setShowModalDeleteUserAgent] =
    useState(false);
  const [messageError, updateMessageError] = useState("");
  const [showModalError, updateShowModalError] = useState(false);

  const history = useHistory();

  const rowsRef: any = useRef([]);
  const itemsTwo = (props) => {
    const { data, userInfo } = props;
    const profileAdmin =
      userInfo.email === data.email &&
      userInfo.profile.name === "Administrador";
    const administradorProfile = data.role.profile.name === "Administrador";

    return profileAdmin
      ? [
          {
            label: "View",
            icon: "pi pi-times",
            template: function Edit(item, options) {
              return (
                <>
                  <DivUserMenu
                    marginTop="1.5rem"
                    marginLeft="1.5rem"
                    key={item}
                    className={options.className}
                    onClick={options.onClick}
                    marginBottom="1rem"
                  >
                    <span>
                      <img
                        src={IconViewUser}
                        height="20px"
                        width="20px"
                        alt=""
                      />
                    </span>
                    <DivUserMenuLabel
                      fontSize="1.4rem"
                      marginLeft="1.5rem"
                      fontWeight="600"
                    >
                      Ver usuario
                    </DivUserMenuLabel>
                  </DivUserMenu>
                </>
              );
            },
            command: () => {
              setDataUserEdit(props);
              setDataUser(data);
              showEdit();
            },
          },
        ]
      : [
          {
            label: "Delete",
            icon: "pi pi-times",
            template: function Edit(item, options) {
              return (
                <>
                  <DivUserMenu
                    marginTop="1.5rem"
                    marginLeft="1.5rem"
                    key={item}
                    className={options.className}
                    onClick={administradorProfile ? null : options.onClick}
                    disabled={administradorProfile}
                  >
                    <span>
                      <img
                        src={
                          administradorProfile ? IconEditUserCris : IconEditUser
                        }
                        height="20px"
                        width="20px"
                        alt=""
                      />
                    </span>
                    <DivUserMenuLabel
                      fontSize="1.4rem"
                      marginLeft="1.5rem"
                      fontWeight="600"
                    >
                      Editar usuario
                    </DivUserMenuLabel>
                  </DivUserMenu>
                </>
              );
            },
            command: () => {
              setDataUserEdit(props);
              setDataUser(data);
              showEdit();
            },
          },
          {
            label: "Delete",
            icon: "pi pi-times",
            template: function Save(item, options) {
              return (
                <>
                  <DivUserMenu
                    marginTop="1.5rem"
                    marginLeft="1.5rem"
                    marginBottom="1.5rem"
                    key={item}
                    className={options.className}
                    onClick={administradorProfile ? null : options.onClick}
                    disabled={administradorProfile}
                  >
                    <span>
                      <img
                        src={
                          administradorProfile
                            ? IconTrashUserCris
                            : IconTrashUser
                        }
                        height="20px"
                        width="20px"
                        alt=""
                      />
                    </span>
                    <DivUserMenuLabel
                      fontSize="1.4rem"
                      marginLeft="1.5rem"
                      fontWeight="600"
                    >
                      Eliminar usuario
                    </DivUserMenuLabel>
                  </DivUserMenu>
                </>
              );
            },
            command: () => {
              setDataUser(data);
              onClose();
            },
          },
        ];
  };

  const gridTemplateColumnsUsersIntranet = "1fr 1fr 1fr 1fr 0.3fr";

  return (
    <div>
      <UsersContainer>
        {loadUsers.isError && (
          <div>
            Algo salió mal
            <button
              type="button"
              onClick={() => {
                loadUsers.retry();
              }}
            >
              Reintentar
            </button>
          </div>
        )}
        {loadUsers.isSuccess && loadUsers.data.users.length < 1 && (
          <StandaloneMessage>No se encontraron usuarios.</StandaloneMessage>
        )}
        {loadUsers.status === "PROCESSING" && (
          <>
            <PaymentLoader numItems={ITEMS_PER_PAGE} />
          </>
        )}
        <ContainerScrollCommon>
          <ContainerConfigurateCommon>
            <ContainerGridColumnsTableCommon
              gridTemplateColumns={gridTemplateColumnsUsersIntranet}
            >
              {loadUsers.isSuccess && loadUsers.data.users.length > 0 && (
                <TableHeaderCommonResponsive className="item-container">
                  <div
                    className="left-aligned-header"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      marginLeft: "2rem",
                    }}
                  >
                    USUARIO
                  </div>
                  <div>CELULAR</div>
                  <div>CORREO</div>
                  <div>PERFIL</div>
                  <div>ACCIONES</div>
                </TableHeaderCommonResponsive>
              )}
              <div
                style={{ overflowY: "scroll", maxHeight: "90vh" }}
                className="scroll"
              >
                {loadUsers.isSuccess &&
                  loadUsers.data.users.map((data, i) => {
                    return (
                      <BodyContainerTableCommon
                        className="item-container"
                        height="7rem"
                      >
                        <div
                          className="attribute"
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            height: "100%",
                          }}
                        >
                          <div className="titles">{"USUARIO"}</div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "self-start",
                            }}
                          >
                            <VolanteId>{data.document_number}</VolanteId>
                            <div>{data.full_name}</div>
                          </div>
                        </div>
                        <div className="attribute" style={{ height: "100%" }}>
                          <div className="titles">{"CELULAR"}</div>
                          <div className="left-align" style={{ width: "100%" }}>
                            <div>{data.phone_number}</div>
                          </div>
                        </div>
                        <div className="attribute" style={{ height: "100%" }}>
                          <div className="titles">{"CORREO"}</div>
                          <div className="left-align" style={{ width: "100%" }}>
                            <div>{data.email}</div>
                          </div>
                        </div>
                        <div className="attribute" style={{ height: "100%" }}>
                          <div className="titles">{"PERFIL"}</div>
                          <div className="left-align" style={{ width: "100%" }}>
                            <div>
                              <b style={{ textAlign: "center" }}>
                                {data.role.profile.name}
                              </b>
                            </div>
                          </div>
                        </div>
                        <div className="attribute" style={{ height: "100%" }}>
                          <div className="titles">{"ACCIONES"}</div>
                          <div className="left-align" style={{ width: "100%" }}>
                            <MenuContainerUser>
                              <Menu
                                style={{
                                  width: "28.2rem",
                                  borderRadius: "8px",
                                }}
                                model={itemsTwo({ ...data, userInfo, data })}
                                popup
                                ref={(elRef) => (rowsRef.current[i] = elRef)}
                                id="popup_menu_two"
                              />
                              <img
                                src={IconItem}
                                width="25px"
                                height="25px"
                                alt=""
                                onClick={(event) => {
                                  rowsRef.current[i].toggle(event);
                                }}
                                style={{ cursor: "pointer" }}
                              />
                            </MenuContainerUser>
                          </div>
                        </div>
                      </BodyContainerTableCommon>
                    );
                  })}
              </div>
            </ContainerGridColumnsTableCommon>
          </ContainerConfigurateCommon>
        </ContainerScrollCommon>

        <DivMarginTop>
          <div>
            {loadUsers.isSuccess && loadUsers.data.users.length > 0 && (
              <Paginator
                first={(loadUsers.data.page - 1) * loadUsers.data.page_size}
                rows={loadUsers.data.page_size}
                totalRecords={loadUsers.data.count}
                onPageChange={(e) => {
                  const targetPage = e.first / loadUsers.data.page_size;
                  const queryParams = {
                    ...queryString.parse(window.location.search),
                    page: targetPage + 1,
                  };
                  const pathname = history.location.pathname;
                  history.push(
                    `${pathname}?${queryString.stringify(queryParams)}`
                  );
                }}
              />
            )}
          </div>
          <div>
            <div className="justify-end-div">
              {loadUsers.isSuccess && (
                <Authorization actions={["user.create_users"]}>
                  <MainButton onClick={showEdit}>Crear usuario</MainButton>
                </Authorization>
              )}
            </div>
          </div>
        </DivMarginTop>

        {showModalEdit && (
          <UsersManagementSidebar
            dataUserEdit={dataUserEdit}
            toggleModal={() => {
              updateModalEdit(false);
              setDataUserEdit(false);
              setShowProfileTwoShowUser(false);
            }}
            loadUsers={loadUsers}
            showModalEdit={showModalEdit}
            setDataUserEdit={setDataUserEdit}
            showModalHide={showModalHide}
            userCompanyMe={userCompanyMe}
            userProfileMe={userProfileMe}
            userInfo={userInfo}
            setMessageTypeEditCreate={setMessageTypeEditCreate}
            settitleTypeEditCreate={settitleTypeEditCreate}
            showProfileTwoShowUser={showProfileTwoShowUser}
          />
        )}
        {showModalDelete && (
          <Modal onOutsideClick={onClose}>
            <Container1>
              <h1>Confirmación de eliminación</h1>
              <div className="description">
                <p>
                  ¿Estás seguro que deseas eliminar al usuario{" "}
                  <b>{dataUser && dataUser.full_name}</b>?
                </p>
              </div>
              <div className="button-container">
                <Button
                  status="confirm"
                  onClick={() => {
                    deleteUser.execute(dataUser);
                  }}
                  disabled={deleteUser.isLoading}
                >
                  {deleteUser.isLoading && (
                    <img className="icon" src={LoadingSpinner} alt="spinner" />
                  )}
                  Eliminar usuario
                </Button>
                <Button status="cancel" onClick={onClose}>
                  Cancelar
                </Button>
              </div>
            </Container1>
          </Modal>
        )}
        {showModalError && messageError && (
          <ConfirmationModal
            message={messageError}
            onAccept={() => {
              updateMessageError("");
              updateShowModalError(false);
              const params = { ...loadUsers.getExecution().params, page: 1 };
              loadUsers.execute(params);
            }}
            title={`Atención`}
            toggleModal={() => {
              updateMessageError("");
              updateShowModalError(false);
              const params = { ...loadUsers.getExecution().params, page: 1 };
              loadUsers.execute(params);
            }}
          />
        )}
        {showModalDeleteUserAgent && (
          <ConfirmationModal
            message={`El usuario ${dataUser.full_name} ha sido eliminado exitosamente`}
            onAccept={() => {
              setShowModalDeleteUserAgent(false);
              const params = { ...loadUsers.getExecution().params, page: 1 };
              loadUsers.execute(params);
            }}
            title={`Usuario eliminado exitosamente`}
            toggleModal={() => {
              setShowModalDeleteUserAgent(false);
              const params = { ...loadUsers.getExecution().params, page: 1 };
              loadUsers.execute(params);
            }}
          />
        )}
        <Authorization actions={["user.delete_users"]}>
          {showModalConfimation && (
            <ConfirmationModal
              message={messageTypeEditCreate}
              onAccept={() => {
                showModalHide();
                const params = { ...loadUsers.getExecution().params, page: 1 };
                loadUsers.execute(params);
              }}
              title={titleTypeEditCreate}
              toggleModal={() => {
                showModalHide();
                const params = { ...loadUsers.getExecution().params, page: 1 };
                loadUsers.execute(params);
              }}
            />
          )}
        </Authorization>
      </UsersContainer>
    </div>
  );
};

export default UsersManagementTableNew;
